import { Checkbox, InputNumber, Select, Text, SelectSizes, InputSizes } from '@clockout-dev/design-elements';
import { CRITERIA_OPERATOR_OPTIONS } from '../../../configuration.constants';
import styles from '../styles/userEligibilityForm.module.scss';

function RestrictedCriterionCard({
    def,
    criterion,
    readOnly,
    onToggle,
    onChangeOperator,
    onChangeValue,
    onChangeWindowDays
}) {
    // Ensure we have valid values, falling back to sensible defaults
    const {
        enabled = false,
        operator = 'gt',
        value = 1,
        window_days = 30
    } = criterion || {};

    const controlsDisabled = readOnly || !enabled;

    return (
        <div className={`${styles.criterionCard} ${enabled && !readOnly ? '' : styles.criterionCardDisabled}`}>
            <div className={styles.criterionHeader}>
                <Checkbox
                    checked={!!enabled}
                    onChange={readOnly ? undefined : onToggle}
                    disabled={readOnly}
                    size="medium"
                />
                <div className={styles.criterionHeaderText}>
                    <Text as="span" size="s" className={styles.criterionTitle}>
                        {def.title}
                    </Text>
                    <Text as="span" size="xs" className={styles.criterionDescription}>
                        {def.description}
                    </Text>
                </div>
            </div>
            <div className={styles.criterionControls} aria-disabled={controlsDisabled || undefined}>
                <Select
                    size={SelectSizes.SMALL}
                    id={`${def.key}-operator`}
                    value={operator}
                    options={CRITERIA_OPERATOR_OPTIONS}
                    disabled={controlsDisabled}
                    onChange={onChangeOperator}
                    className={styles.criterionOperator}
                />
                <InputNumber
                    size={InputSizes.SMALL}
                    value={value}
                    onChange={onChangeValue}
                    disabled={controlsDisabled}
                    min={0}
                    max={9999}
                    step={1}
                    precision={0}
                    controls={false}
                    className={styles.criterionValueInput}
                />
                <Text as="span" size="s" className={styles.criterionUnit}>
                    {def.unit}
                </Text>
                {def.windowed && (
                    <>
                        <Text as="span" size="s" className={styles.criterionUnit}>
                            In the last
                        </Text>
                        <InputNumber
                            size={InputSizes.SMALL}
                            value={window_days}
                            onChange={onChangeWindowDays}
                            disabled={controlsDisabled}
                            min={1}
                            max={365}
                            step={1}
                            precision={0}
                            controls={false}
                            className={styles.criterionWindowInput}
                        />
                        <Text as="span" size="s" className={styles.criterionUnit}>
                            days
                        </Text>
                    </>
                )}
            </div>
        </div>
    );
}

export default RestrictedCriterionCard;
